import React, {ChangeEvent, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

interface LocalityInputProps {
    locality: string;
    onSetLocality: (amount: string) => void;
    onSetIsLocalityValid: (isLocalityValid: boolean) => void;
}

export const LocalityInput: React.FunctionComponent<LocalityInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const requiredLocalityError = 'Locality is a required field.';
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    useEffect(() => {
        props.onSetIsLocalityValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        props.onSetLocality((event.target as HTMLInputElement).value);
        validateLocality();
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateLocality();
    }

    const validateLocality = () => {
        let errorsTemp: string[] = [];
        if (props.locality === '') {
            errorsTemp.push(requiredLocalityError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        setIsSubmitted(true);
        validateLocality();
    }

    return <div>
        <Input isValid={isValid} type='text' required={true} value={props.locality} onChange={onChange}
               onKeyUp={onKeyUp} onBlur={onBlur}/>
        {isSubmitted && errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
